import ObjectPreviewCard from './ObjectPreviewCard.component';

export default ObjectPreviewCard;